import { useDispatch, useSelector } from "react-redux";
import { MandatoryStar, getSnackbarSuccess } from "../../../Utils/helper";
import { getNetworkMenuId } from "../../../Utils/types";
import { useState } from "react";
import {
  approveRejectTestDetailsActionIBU,
  getPackageDetailNewPopupActionIBU,
  getPackageDetailUpdatePopupActionIBU,
} from "../../../redux/actions/ProviderProfileDetailAction";

export const ConfirmationPackagePopupIBU = ({
  isApproveReject,
  setIsApproveReject,
  rowData,
  handleClose,
  newSearchFilterTest,
  updateSearchFilterTest,
}) => {
  const dispatch = useDispatch();
  const [remark, setRemark] = useState("");

  const ApproveRejectHandler = async (type) => {
    const temp = {
      requestID: rowData?.requestID,
      requestStatus: type,
      sessionID: rowData?.sessionID,
      providerRateMasterStgId: isApproveReject?.providerRateMasterStgId,
      testId: isApproveReject?.testId,
      rate: isApproveReject?.rate,
      remarks: remark,
      providerId: rowData?.providerID,
    };
    if (isApproveReject?.rate == 0 && type === "APPROVED") {
      getSnackbarSuccess("info", "rate should be greater than 0", dispatch);
    } else if (
      isApproveReject?.testId === undefined ||
      isApproveReject?.testId === null ||
      (isApproveReject?.rate === "" && type === "APPROVED")
    ) {
      getSnackbarSuccess(
        "info",
        "Please fill all the required fields",
        dispatch
      );
    } else if (type === "REJECTED" && /^\s*$/.test(remark)) {
      getSnackbarSuccess(
        "info",
        "Please specify the reason for rejecting this request ?",
        dispatch
      );
    } else {
      await dispatch(approveRejectTestDetailsActionIBU(temp, handleClose));
      await dispatch(getPackageDetailNewPopupActionIBU(newSearchFilterTest));
      await dispatch(getPackageDetailUpdatePopupActionIBU(updateSearchFilterTest));
      await setIsApproveReject(null);
      await setRemark("");
    }
  };

  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">Approval Card </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => setIsApproveReject(null)}
        ></button>
      </div>
      <form className="form-admin test-confirmationpopup">
        <div className="modal-body addusermodalbox">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <label htmlFor=" Role" className="col-form-label">
                Rate <MandatoryStar />
              </label>
              <input
                type="text"
                placeholder="Agreed Rate"
                className="form-control form-select-admin inputbgavanish"
                value={isApproveReject?.rate}
                onChange={(e) =>
                  setIsApproveReject({
                    ...isApproveReject,
                    rate: e.target.value,
                  })
                }
                onKeyPress={(event) => {
                  const regex = /^[0-9]*(\.[0-9]{0,2})?$/;
                  if (!regex.test(isApproveReject?.rate + event.key)) {
                    event.preventDefault();
                  }
                }}
                disabled={isApproveReject?.requestStatus !== "InReview"}
              />
            </div>
            <div className="col-lg-6 col-md-6">
              <label htmlFor=" Role" className="col-form-label">
                Package Name
                <MandatoryStar />
              </label>
              <input
                type="text"
                placeholder="Package Name"
                className="form-control form-select-admin inputbgavanish"
                value={isApproveReject?.packageName}
              />
            </div>
          </div>
          <div className="remarks mt-4 mb-5">
            <h5 className="font-bold text-black bottom-spacing-20 mb-3">
              Remarks
            </h5>
            <textarea
              className="textareaConfirmation font-medium"
              placeholder="Type Something Here..."
              onChange={(e) => setRemark(e.target.value)}
              value={
                isApproveReject?.requestStatus !== "InReview"
                  ? isApproveReject?.remarks
                  : remark
              }
            ></textarea>
          </div>
        </div>
        <div className="modal-footer modal-footer-admin accept-reject-btns bottom-0  mt-4">
          {isApproveReject?.requestStatus === "InReview" &&
            getNetworkMenuId()?.canEdit && (
              <div className="d-flex justify-content-end flex-wrap gap-10">
                <button
                  type="button"
                  onClick={async () => {
                    await ApproveRejectHandler("APPROVED");
                  }}
                  className="approve-btn"
                >
                  Approve
                </button>

                <button
                  type="button"
                  onClick={async () => {
                    await ApproveRejectHandler("REJECTED");
                  }}
                  className="reject-btn"
                >
                  Reject
                </button>
              </div>
            )}
        </div>
      </form>
    </>
  );
};
